import get from 'lodash.get';
import serverVars from 'server-vars';

const getCdnTestData = ({ queryParam, serverVarName }) => {
    const cdnQueryParams = serverVars.get('cdnQueryParams') || {};

    return {
        // If cdn query param exists - test is running.
        isRunning: !!cdnQueryParams[queryParam],
        // If server var and cdn query param is set to "true" - it's test variant.
        isTestVariant: serverVars.get(serverVarName) && cdnQueryParams[queryParam] === 'true',
    };
};

export const cdnTestTracking = ({ item } = {}) => {
    let additional = {};

    const roomTilesTest = getCdnTestData({
        queryParam: 'rooms',
        serverVarName: 'showRoomTiles',
    });

    // The absence of the "rooms" CDN query param means the user is neither in control nor variant
    // We only want to set tracking variable when the "rooms" query param is defined
    if (roomTilesTest.isRunning) {
        additional = {
            cdnTest1: roomTilesTest.isTestVariant ? 'roomTiles - test' : 'categoryTiles - control',
        };
    }

    const negotiableBadgeTest = getCdnTestData({
        queryParam: 'negotiableBadge',
        serverVarName: 'showNegotiableBadge',
    });

    if (negotiableBadgeTest.isRunning) {
        additional = {
            ...additional,
            cdnTest4: negotiableBadgeTest.isTestVariant
                ? 'negotiableBadge - Test'
                : 'negotiableBadge - Control',
        };
    }

    const swapMakeOfferTest = getCdnTestData({
        queryParam: 'swapMakeOffer',
        serverVarName: 'swapMakeOffer',
    });

    if (swapMakeOfferTest.isRunning && get(item, 'displayInfo.ctas.showMakeOffer')) {
        additional = {
            ...additional,
            cdnTest2: swapMakeOfferTest.isTestVariant
                ? 'makeOfferTop - Test'
                : 'makeOfferBottom - Control',
        };
    }

    return additional;
};

export const cdnTestEcommerceTracking = ({ item }) => {
    let variants = {};

    const negotiableBadgeTest = getCdnTestData({
        queryParam: 'negotiableBadge',
        serverVarName: 'showNegotiableBadge',
    });

    if (negotiableBadgeTest.isRunning) {
        variants = {
            variant: get(item, 'displayInfo.ctas.showMakeOffer') ? 'negotiable' : 'non-negotiable',
        };
    }

    return variants;
};
